export type ReferencePriceModelIdReducerState = string | null;

export const referencePriceModelIdReducerInitialState: ReferencePriceModelIdReducerState =
  null;

export enum referencePriceModelIdActionTypes {
  UPDATE_PRICEMODEL_ID = 'REFERENCE_PRICEMODEL_ID_UPDATE',
}

export interface ReferencePriceModelIdReducerAction {
  type: referencePriceModelIdActionTypes;
  payload: string | null;
}

const referencePriceModelIdReducer = (
  state: ReferencePriceModelIdReducerState,
  action: ReferencePriceModelIdReducerAction
): ReferencePriceModelIdReducerState => {
  switch (action.type) {
    case referencePriceModelIdActionTypes.UPDATE_PRICEMODEL_ID: {
      return action.payload;
    }
    default:
      return state;
  }
};

export default referencePriceModelIdReducer;
